import React from "react";

import "./HeadingText.scss";

interface IHeadingTextProps {
  text: string;
  isMainHeading?: boolean;
  image?: string;
}

const HeadingText: React.FunctionComponent<IHeadingTextProps> = ({
  text,
  isMainHeading,
  image,
}) => {
  return (
    <>
      {image && <img className="feature-image" src={image} />}
      <h1 className={isMainHeading ? "main-heading" : "sub-heading"}>{text}</h1>
    </>
  );
};

HeadingText.defaultProps = {
  isMainHeading: true,
};

export default HeadingText;
